import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';


const drawerWidth = 240;
const navItems = ['Home', 'Robotics', 'Automobiles', 'Gallery', 'Contact'];

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
         <Link to="/" style={{ textDecoration: 'none' }}>
            Vivek
          </Link> 
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <Link to={item} style={{ textDecoration: 'none' }}>
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
            
             <ListItemText primary={item} />
            
            </ListItemButton>
          </ListItem>
          </Link>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', flexGrow: 1, position: 'absolute', zIndex: "1", width: '100vw', }}>
      <CssBaseline />
      <AppBar sx={{ background: 'transparent', boxShadow: 'none', px: "5%", }} component="nav" position='static'>
        <Toolbar>

        <Typography variant="h6" component="div" sx={{ flexGrow: 1, display: { sm: 'none' }, color: '#3A3A3A' }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
            Vivek
          </Link> 
          </Typography>

          <IconButton
            size='large'
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' }, }}
          >
            <MenuIcon  />
          </IconButton>
          
          <Typography
            variant="h4"
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' }, color: '#3A3A3A' }}
          >
            <Link to="/" style={{ textDecoration: 'none' }}>
            Vivek
            </Link>  
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item) => (
              <Link to={item} style={{ textDecoration: 'none' }}>
              <Button key={item} sx={{ color: '#C7C7C7' }}>
                {item}
              </Button>
              </Link>
              
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};



export default DrawerAppBar;
